export const nodeColors = [
  {"background":"#3CB44B","textColor":"#FFFFFF"},
  {"background":"#F58231","textColor":"#000000"},
  {"background":"#FFE119","textColor":"#000000"},
  {"background":"#911EB4","textColor":"#FFFFFF"},
  {"background":"#0082C8","textColor":"#FFFFFF"},
  {"background":"#F032E6","textColor":"#FFFFFF"},
  {"background":"#46F0F0","textColor":"#000000"},
  {"background":"#D2F53C","textColor":"#000000"},
  {"background":"#008080","textColor":"#FFFFFF"},
  {"background":"#E6BEFF","textColor":"#000000"},
  {"background":"#E6194B","textColor":"#FFFFFF"},
  {"background":"#FABEBE","textColor":"#000000"},
  {"background":"#AA6E28","textColor":"#FFFFFF"},
  {"background":"#FFFAC8","textColor":"#000000"},
  {"background":"#800000","textColor":"#FFFFFF"},
  {"background":"#AAFFC3","textColor":"#000000"},
  {"background":"#808000","textColor":"#FFFFFF"},
  {"background":"#FFD8B1","textColor":"#000000"},
  {"background":"#000080","textColor":"#FFFFFF"},
  {"background":"#808080","textColor":"#FFFFFF"},
  {"background":"#FFFFFF","textColor":"#000000"},
  {"background":"#000000","textColor":"#FFFFFF"},
  {"background":"#FF7F50","textColor":"#000000"},
  {"background":"#B0E0E6","textColor":"#000000"},
  {"background":"#6A5ACD","textColor":"#FFFFFF"},
  {"background":"#20B2AA","textColor":"#FFFFFF"},
  {"background":"#FF69B4","textColor":"#000000"},
  {"background":"#CD5C5C","textColor":"#FFFFFF"},
  {"background":"#4B0082","textColor":"#FFFFFF"},
  {"background":"#7FFF00","textColor":"#000000"},
  {"background":"#DC143C","textColor":"#FFFFFF"},
  {"background":"#00CED1","textColor":"#000000"},
  {"background":"#ADFF2F","textColor":"#000000"},
  {"background":"#C71585","textColor":"#FFFFFF"},
  {"background":"#5F9EA0","textColor":"#FFFFFF"},
  {"background":"#FF8C00","textColor":"#000000"},
  {"background":"#2E8B57","textColor":"#FFFFFF"},
  {"background":"#9ACD32","textColor":"#000000"},
  {"background":"#6B8E23","textColor":"#FFFFFF"},
  {"background":"#40E0D0","textColor":"#000000"},
  {"background":"#BA55D3","textColor":"#FFFFFF"},
  {"background":"#9370DB","textColor":"#FFFFFF"},
  {"background":"#F0E68C","textColor":"#000000"},
  {"background":"#4682B4","textColor":"#FFFFFF"},
  {"background":"#708090","textColor":"#FFFFFF"},
  {"background":"#D2691E","textColor":"#FFFFFF"},
  {"background":"#B22222","textColor":"#FFFFFF"},
  {"background":"#6495ED","textColor":"#FFFFFF"},
  {"background":"#F5DEB3","textColor":"#000000"},
  {"background":"#D8BFD8","textColor":"#000000"},
  {"background":"#556B2F","textColor":"#FFFFFF"},
  {"background":"#8B0000","textColor":"#FFFFFF"},
  {"background":"#00FA9A","textColor":"#000000"},
  {"background":"#1E90FF","textColor":"#FFFFFF"},
  {"background":"#FF1493","textColor":"#FFFFFF"},
  {"background":"#A0522D","textColor":"#FFFFFF"},
  {"background":"#90EE90","textColor":"#000000"},
  {"background":"#483D8B","textColor":"#FFFFFF"},
  {"background":"#32CD32","textColor":"#000000"},
  {"background":"#A52A2A","textColor":"#FFFFFF"},
  {"background":"#FF4500","textColor":"#FFFFFF"},
  {"background":"#FFD700","textColor":"#000000"},
  {"background":"#DA70D6","textColor":"#000000"},
  {"background":"#8A2BE2","textColor":"#FFFFFF"},
  {"background":"#EEE8AA","textColor":"#000000"},
  {"background":"#7CFC00","textColor":"#000000"},
  {"background":"#F08080","textColor":"#000000"},
  {"background":"#FFA07A","textColor":"#000000"},
  {"background":"#00BFFF","textColor":"#000000"},
  {"background":"#663399","textColor":"#FFFFFF"},
  {"background":"#BDB76B","textColor":"#000000"},
  {"background":"#8FBC8F","textColor":"#000000"},
  {"background":"#DCEDC8","textColor":"#000000"},
  {"background":"#FFE4B5","textColor":"#000000"},
  {"background":"#C0C0C0","textColor":"#000000"},
  {"background":"#778899","textColor":"#FFFFFF"},
  {"background":"#B8860B","textColor":"#FFFFFF"},
  {"background":"#191970","textColor":"#FFFFFF"},
  {"background":"#AFEEEE","textColor":"#000000"},
  {"background":"#E9967A","textColor":"#000000"},
  {"background":"#DDA0DD","textColor":"#000000"},
  {"background":"#4169E1","textColor":"#FFFFFF"},
  {"background":"#FA8072","textColor":"#000000"},
  {"background":"#BC8F8F","textColor":"#000000"},
  {"background":"#2F4F4F","textColor":"#FFFFFF"},
  {"background":"#228B22","textColor":"#FFFFFF"},
  {"background":"#F5F5DC","textColor":"#000000"},
  {"background":"#9932CC","textColor":"#FFFFFF"},
  {"background":"#FFDEAD","textColor":"#000000"},
  {"background":"#FFE4E1","textColor":"#000000"},
  {"background":"#DEB887","textColor":"#000000"},
  {"background":"#CD853F","textColor":"#FFFFFF"},
  {"background":"#E0FFFF","textColor":"#000000"},
  {"background":"#FFD700","textColor":"#000000"},
  {"background":"#00FF7F","textColor":"#000000"},
  {"background":"#B0C4DE","textColor":"#000000"},
  {"background":"#008B8B","textColor":"#FFFFFF"},
  {"background":"#556B2F","textColor":"#FFFFFF"}
]
